import { TESTCASE_SEVERITY, TESTCASE_STATUS } from '@pages/testcases/constants/testcasesСonstants';
import { Scheme, SchemeFormData } from '@pages/schemes/types';
import { AccessEnum } from '@shared/types';

export const INITIAL_TEST_CASE_DATA = {
    name: '',
    is_handtest: true,
    status: TESTCASE_STATUS.DRAFT,
    severity: TESTCASE_SEVERITY.MEDIUM,
    objective: {},
    precondition: {},
    test_data: {},
    scheme: null,
    module: null,
    test_scripts: [
        {
            id: String(Date.now()),
            script: {},
            result: {},
        },
    ],
    postcondition: {},
    attachments: [],
    tags: [],
    team: '',
};

export const INITIAL_HAND_TEST_CASE_RESULT_DATA = {
    precondition: '',
    test_steps: {},
    postcondition: '',
};

export const INITIAL_TEST_PLAN_DATA = {
    title: '',
    description: '',
    testcases: [],
    testcases_ids: [],
    status: 'Draft',
};

export const INITIAL_SCHEME_DATA: Scheme = {
    pk: 1,
    name: '',
    description: '',
    json_config: {
        nodes: [],
        edges: [],
    },
    modules: [],
    tags: [],
    preview: null,
    createdAt: '',
    created_by_user: null,
    access: AccessEnum.Locked,
    testcase: null,
    testcases_cnt: 0,
    stands_cnt: 0,
};

const { pk, preview, createdAt, created_by_user, testcase, testcases_cnt, ...initialFormSchemeData } =
    INITIAL_SCHEME_DATA;
export const INITIAL_FORM_SCHEME_DATA: SchemeFormData = initialFormSchemeData;

export const INITIAL_TABLE_PAGINATION = {
    pageIndex: 0,
    pageSize: 25,
};

export const INITIAL_SCHEME_PAGINATION = {
    pageIndex: 1,
    pageSize: 6,
};

export const INITIAL_TESTCASE_RESULTS_FILTER = {
    status: '',
    version: '',
    build: '',
    onlyLast: false,
    dateRange: null,
    user: null,
};

// GENERATOR start
export const MAP_RULESET_TYPE_TO_SECTIONS = {
    firewall: [
        'action',
        'reject with',
        'logging',
        'apply rule to',
        'source zones',
        'destination zones',
        'source ip lists',
        'destination ip lists',
        'users',
        'services',
    ],
    // NAT key contains nat_${type_of_nat_rule}
    nat_nat: [
        'snat ip address',
        'logging',
        'source zones',
        'destination zones',
        'source ip lists',
        'destination ip lists',
        'services',
    ],
    nat_policy_based_routing: [
        'gateways',
        'logging',
        'source zones',
        'source ip lists',
        'destination ip lists',
        'users',
        'services',
    ],
    nat_port_forwarding: [
        'snat ip address',
        'port forwarding',
        'dnat',
        'logging',
        'source zones',
        'source ip lists',
        'destination ip lists',
    ],
    nat_dnat: [
        'snat ip address',
        'dnat',
        'logging',
        'source zones',
        'source ip lists',
        'destination ip lists',
        'services',
    ],
    nat_network_mapping: [
        'network mapping',
        'logging',
        'source zones',
        'source ip lists',
        'destination ip lists',
        'services',
    ],
};

export const DEFAULT_RULE_CONTAINER_DATA = {
    name: 'New rules container',
    percent: 1,
    is_percent_locked: false,
    settings_sections: [],
};

export const DEFAULT_CONTAINER_SETTING_DATA__ACTION = [
    {
        kind: 'random',
        percent: 50,
        is_percent_locked: false,
    },
    {
        kind: 'allow',
        percent: 25,
        is_percent_locked: false,
    },
    {
        kind: 'deny',
        percent: 25,
        is_percent_locked: false,
    },
];

export const DEFAULT_CONTAINER_SETTING_DATA__REJECT_WITH = [
    {
        kind: 'Not set',
        percent: 50,
        is_percent_locked: false,
    },
    {
        kind: 'ICMP',
        percent: 20,
        is_percent_locked: false,
    },
    {
        kind: 'TCPR',
        percent: 20,
        is_percent_locked: false,
    },
    {
        kind: 'TCPR_BOTH',
        percent: 10,
        is_percent_locked: false,
    },
];
export const DEFAULT_CONTAINER_SETTING_DATA__LOGGING = [
    {
        kind: 'no logging',
        percent: 50,
        is_percent_locked: false,
    },
    {
        kind: 'log session start',
        percent: 50,
        is_percent_locked: false,
    },
];

export const DEFAULT_CONTAINER_SETTING_DATA__APPLY_RULE_TO = [
    {
        kind: 'any packets',
        percent: 25,
        is_percent_locked: false,
    },
    {
        kind: 'fragmented',
        percent: 25,
        is_percent_locked: false,
    },
    {
        kind: 'not fragmented',
        percent: 50,
        is_percent_locked: false,
    },
];

export const DEFAULT_CONTAINER_SETTING_DATA__ZONES = [
    {
        kind: {
            items: ['Any zone'],
        },
        percent: 100,
        is_percent_locked: false,
    },
];
export const DEFAULT_CONTAINER_SETTING_DATA__IP_LISTS = [
    {
        kind: {
            item: 'No IP lists',
        },
        percent: 100,
        is_percent_locked: false,
    },
];

export const DEFAULT_CONTAINER_SETTING_DATA__USERS = [
    {
        kind: {
            items: ['Any users'],
        },
        percent: 100,
        is_percent_locked: false,
    },
];

export const DEFAULT_CONTAINER_SETTING_DATA__SERVICES = [
    {
        kind: {
            items: 'Any services',
        },
        percent: 100,
        is_percent_locked: false,
    },
];

export const DEFAULT_CONTAINER_SETTING_DATA__SNAT_IP_ADDRESS = [
    {
        kind: 'None',
        percent: 100,
        is_percent_locked: false,
    },
];

// DO NOT NEED NOW
export const DEFAULT_CONTAINER_SETTING_DATA__GATEWAYS = [
    {
        kind: '',
        type: 'single_ip_address',
        percent: 100,
        is_percent_locked: false,
    },
];

export const DEFAULT_CONTAINER_SETTING_DATA__PORT_FORWARDING = [
    {
        kind: 'Not set',
        percent: 100,
        is_percent_locked: false,
    },
];

export const DEFAULT_CONTAINER_SETTING_DATA__NETWORK_MAPPING = [
    {
        kind: '',
        direction: 'input',
        type: 'single_ip_address',
        percent: 100,
        is_percent_locked: false,
    },
];

export const DEFAULT_CONTAINER_SETTING_DATA__DNAT = [
    {
        kind: '',
        type: 'single_ip_address',
        percent: 100,
        is_percent_locked: false,
    },
];

export const MAP_SETTING_TO_DEFAULT_DATA = {
    action: DEFAULT_CONTAINER_SETTING_DATA__ACTION,
    'reject with': DEFAULT_CONTAINER_SETTING_DATA__REJECT_WITH,
    logging: DEFAULT_CONTAINER_SETTING_DATA__LOGGING,
    'apply rule to': DEFAULT_CONTAINER_SETTING_DATA__APPLY_RULE_TO,
    'source zones': DEFAULT_CONTAINER_SETTING_DATA__ZONES,
    'destination zones': DEFAULT_CONTAINER_SETTING_DATA__ZONES,
    'source ip lists': DEFAULT_CONTAINER_SETTING_DATA__IP_LISTS,
    'destination ip lists': DEFAULT_CONTAINER_SETTING_DATA__IP_LISTS,
    users: DEFAULT_CONTAINER_SETTING_DATA__USERS,
    services: DEFAULT_CONTAINER_SETTING_DATA__SERVICES,
    'snat ip address': DEFAULT_CONTAINER_SETTING_DATA__SNAT_IP_ADDRESS,
    gateways: DEFAULT_CONTAINER_SETTING_DATA__GATEWAYS,
    'port forwarding': DEFAULT_CONTAINER_SETTING_DATA__PORT_FORWARDING,
    'network mapping': DEFAULT_CONTAINER_SETTING_DATA__NETWORK_MAPPING,
    dnat: DEFAULT_CONTAINER_SETTING_DATA__DNAT,
};

export const NAT_TYPES = ['NAT', 'DNAT', 'Port forwarding', 'Policy based routing', 'Network mapping'];
export const RULESET_TYPES = ['Firewall', 'NAT'];
export const MAP_RULESET_TYPE_TO_COLOR = {
    firewall: 'var(--charts-deep-purple)',
    nat: 'var(--charts-blue)',
};
export const MAP_RULESET_TYPE_TO_ID_PREFIX = {
    firewall: 'FRW',
    nat: 'NAT',
};

export const MAP_RULESET_TYPE_TO_LABEL = {
    firewall: 'Firewall',
    nat: 'NAT',
};

export const REQUIRED_TO_FILL_TABS = ['gateways', 'dnat', 'network mapping'];
// GENERATOR end
